<template>
<div>
  <CenterizedTile @click="dialog=true">
    <IconifiedTile>
      <template #icon>
        <v-icon size="60" :color="color">mdi-motion-sensor</v-icon>
      </template>
      <template #value>{{ motionState }}</template>
      <template #title>{{ config.name || $t(`type.${info.type}`) }}</template>
    </IconifiedTile>
  </CenterizedTile>
  <MotionHistoryDialog v-if="dialog" v-model="dialog" :device="device" :endpoint="endpointId" @setting="showSettingsDialog"></MotionHistoryDialog></div>
</template>

<script>
import EndpointTile from '@/components/tile/EndpointTile'
import CenterizedTile from '@/components/tile/CenterizedTile'
import IconifiedTile from '@/components/tile/IconifiedTile'
import MotionHistoryDialog from '@/components/history/MotionHistoryDialog'

export default {
  name: 'MotionTile',
  mixins: [EndpointTile],
  components: {
    CenterizedTile,
    IconifiedTile,
    MotionHistoryDialog
  },
  computed: {
    motionState() {
      return this.report.motionState ? this.$t(`motion.${this.report.motionState}`) : '---';
    },
    color() {
      switch (this.report.motionState) {
        case 'DETECTED':
          return 'red';
        default:
          return 'grey';
      }
    }
  }
}
</script>
